// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/types/google_authenticator.proto" (package "mlmbox.types", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Status_GoogleAuthenticatorVerifiedCode } from "./status.ts";
import { Status_GoogleAuthenticator } from "./status.ts";
/**
 * @generated from protobuf message mlmbox.types.GoogleAuthenticator
 */
export interface GoogleAuthenticator {
    /**
     * @generated from protobuf field: mlmbox.types.Status.GoogleAuthenticator status = 1;
     */
    status: Status_GoogleAuthenticator;
    /**
     * @generated from protobuf field: uint32 modified_at = 2;
     */
    modifiedAt: number;
}
/**
 * @generated from protobuf message mlmbox.types.GoogleAuthenticator.Status
 */
export interface GoogleAuthenticator_Status {
    /**
     * @generated from protobuf field: mlmbox.types.Status.GoogleAuthenticator status = 1;
     */
    status: Status_GoogleAuthenticator;
}
/**
 * @generated from protobuf message mlmbox.types.GoogleAuthenticator.SecretCode
 */
export interface GoogleAuthenticator_SecretCode {
    /**
     * @generated from protobuf field: string secret_code = 1;
     */
    secretCode: string;
}
/**
 * @generated from protobuf message mlmbox.types.GoogleAuthenticator.VerifiedCode
 */
export interface GoogleAuthenticator_VerifiedCode {
}
/**
 * @generated from protobuf message mlmbox.types.GoogleAuthenticator.VerifiedCode.Request
 */
export interface GoogleAuthenticator_VerifiedCode_Request {
    /**
     * @generated from protobuf field: string verified_code = 1;
     */
    verifiedCode: string;
}
/**
 * @generated from protobuf message mlmbox.types.GoogleAuthenticator.VerifiedCode.Response
 */
export interface GoogleAuthenticator_VerifiedCode_Response {
    /**
     * @generated from protobuf field: mlmbox.types.Status.GoogleAuthenticatorVerifiedCode status = 1;
     */
    status: Status_GoogleAuthenticatorVerifiedCode;
    /**
     * @generated from protobuf field: mlmbox.types.GoogleAuthenticator result = 2;
     */
    result?: GoogleAuthenticator; // not empty when [status_id == APPROVED]
}
// @generated message type with reflection information, may provide speed optimized methods
class GoogleAuthenticator$Type extends MessageType<GoogleAuthenticator> {
    constructor() {
        super("mlmbox.types.GoogleAuthenticator", [
            { no: 1, name: "status", kind: "enum", T: () => ["mlmbox.types.Status.GoogleAuthenticator", Status_GoogleAuthenticator, "GOOGLE_AUTHENTICATOR_"] },
            { no: 2, name: "modified_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<GoogleAuthenticator>): GoogleAuthenticator {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        message.modifiedAt = 0;
        if (value !== undefined)
            reflectionMergePartial<GoogleAuthenticator>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GoogleAuthenticator): GoogleAuthenticator {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Status.GoogleAuthenticator status */ 1:
                    message.status = reader.int32();
                    break;
                case /* uint32 modified_at */ 2:
                    message.modifiedAt = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GoogleAuthenticator, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Status.GoogleAuthenticator status = 1; */
        if (message.status !== 0)
            writer.tag(1, WireType.Varint).int32(message.status);
        /* uint32 modified_at = 2; */
        if (message.modifiedAt !== 0)
            writer.tag(2, WireType.Varint).uint32(message.modifiedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.GoogleAuthenticator
 */
export const GoogleAuthenticator = new GoogleAuthenticator$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GoogleAuthenticator_Status$Type extends MessageType<GoogleAuthenticator_Status> {
    constructor() {
        super("mlmbox.types.GoogleAuthenticator.Status", [
            { no: 1, name: "status", kind: "enum", T: () => ["mlmbox.types.Status.GoogleAuthenticator", Status_GoogleAuthenticator, "GOOGLE_AUTHENTICATOR_"] }
        ]);
    }
    create(value?: PartialMessage<GoogleAuthenticator_Status>): GoogleAuthenticator_Status {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<GoogleAuthenticator_Status>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GoogleAuthenticator_Status): GoogleAuthenticator_Status {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Status.GoogleAuthenticator status */ 1:
                    message.status = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GoogleAuthenticator_Status, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Status.GoogleAuthenticator status = 1; */
        if (message.status !== 0)
            writer.tag(1, WireType.Varint).int32(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.GoogleAuthenticator.Status
 */
export const GoogleAuthenticator_Status = new GoogleAuthenticator_Status$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GoogleAuthenticator_SecretCode$Type extends MessageType<GoogleAuthenticator_SecretCode> {
    constructor() {
        super("mlmbox.types.GoogleAuthenticator.SecretCode", [
            { no: 1, name: "secret_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GoogleAuthenticator_SecretCode>): GoogleAuthenticator_SecretCode {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.secretCode = "";
        if (value !== undefined)
            reflectionMergePartial<GoogleAuthenticator_SecretCode>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GoogleAuthenticator_SecretCode): GoogleAuthenticator_SecretCode {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string secret_code */ 1:
                    message.secretCode = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GoogleAuthenticator_SecretCode, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string secret_code = 1; */
        if (message.secretCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.secretCode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.GoogleAuthenticator.SecretCode
 */
export const GoogleAuthenticator_SecretCode = new GoogleAuthenticator_SecretCode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GoogleAuthenticator_VerifiedCode$Type extends MessageType<GoogleAuthenticator_VerifiedCode> {
    constructor() {
        super("mlmbox.types.GoogleAuthenticator.VerifiedCode", []);
    }
    create(value?: PartialMessage<GoogleAuthenticator_VerifiedCode>): GoogleAuthenticator_VerifiedCode {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GoogleAuthenticator_VerifiedCode>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GoogleAuthenticator_VerifiedCode): GoogleAuthenticator_VerifiedCode {
        return target ?? this.create();
    }
    internalBinaryWrite(message: GoogleAuthenticator_VerifiedCode, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.GoogleAuthenticator.VerifiedCode
 */
export const GoogleAuthenticator_VerifiedCode = new GoogleAuthenticator_VerifiedCode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GoogleAuthenticator_VerifiedCode_Request$Type extends MessageType<GoogleAuthenticator_VerifiedCode_Request> {
    constructor() {
        super("mlmbox.types.GoogleAuthenticator.VerifiedCode.Request", [
            { no: 1, name: "verified_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GoogleAuthenticator_VerifiedCode_Request>): GoogleAuthenticator_VerifiedCode_Request {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.verifiedCode = "";
        if (value !== undefined)
            reflectionMergePartial<GoogleAuthenticator_VerifiedCode_Request>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GoogleAuthenticator_VerifiedCode_Request): GoogleAuthenticator_VerifiedCode_Request {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string verified_code */ 1:
                    message.verifiedCode = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GoogleAuthenticator_VerifiedCode_Request, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string verified_code = 1; */
        if (message.verifiedCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.verifiedCode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.GoogleAuthenticator.VerifiedCode.Request
 */
export const GoogleAuthenticator_VerifiedCode_Request = new GoogleAuthenticator_VerifiedCode_Request$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GoogleAuthenticator_VerifiedCode_Response$Type extends MessageType<GoogleAuthenticator_VerifiedCode_Response> {
    constructor() {
        super("mlmbox.types.GoogleAuthenticator.VerifiedCode.Response", [
            { no: 1, name: "status", kind: "enum", T: () => ["mlmbox.types.Status.GoogleAuthenticatorVerifiedCode", Status_GoogleAuthenticatorVerifiedCode, "GOOGLE_AUTHENTICATOR_VERIFIED_CODE_"] },
            { no: 2, name: "result", kind: "message", T: () => GoogleAuthenticator }
        ]);
    }
    create(value?: PartialMessage<GoogleAuthenticator_VerifiedCode_Response>): GoogleAuthenticator_VerifiedCode_Response {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<GoogleAuthenticator_VerifiedCode_Response>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GoogleAuthenticator_VerifiedCode_Response): GoogleAuthenticator_VerifiedCode_Response {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Status.GoogleAuthenticatorVerifiedCode status */ 1:
                    message.status = reader.int32();
                    break;
                case /* mlmbox.types.GoogleAuthenticator result */ 2:
                    message.result = GoogleAuthenticator.internalBinaryRead(reader, reader.uint32(), options, message.result);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GoogleAuthenticator_VerifiedCode_Response, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Status.GoogleAuthenticatorVerifiedCode status = 1; */
        if (message.status !== 0)
            writer.tag(1, WireType.Varint).int32(message.status);
        /* mlmbox.types.GoogleAuthenticator result = 2; */
        if (message.result)
            GoogleAuthenticator.internalBinaryWrite(message.result, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.GoogleAuthenticator.VerifiedCode.Response
 */
export const GoogleAuthenticator_VerifiedCode_Response = new GoogleAuthenticator_VerifiedCode_Response$Type();
